import React, { useRef } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { IoReload } from 'react-icons/io5';

import { ButtonBlack, InputMask } from '~/components';

import Modal from '../Modal';

import {
  ModalFilterContent,
  ModalQuestion2,
  ModalTitle,
  ResetFilterContainer,
} from '../styles';

type Props = {
  loading: boolean;
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  statusFilterOptions: JSX.Element[];
  by: string;
  setBy: React.Dispatch<React.SetStateAction<string>>;
  from: string;
  setFrom: React.Dispatch<React.SetStateAction<string>>;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
  loadFilteredStudents: () => Promise<void>;
};

const FilterModal = ({
  loading,
  modalVisible,
  setModalVisible,
  statusFilterOptions,
  by,
  setBy,
  from,
  setFrom,
  setStatus,
  loadFilteredStudents,
}: Props) => {
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = async () => {
    loadFilteredStudents();
  };

  const resetData = () => {
    setBy('');
    setFrom('');
    setStatus('');
  };

  const inputStyle = {
    padding: '2rem',
  };

  return (
    <Modal
      isOpen={modalVisible}
      setOpen={setModalVisible}
      maxWidthStyled={621}
      maxHeightStyled={528}
    >
      <ModalFilterContent>
        <ModalTitle>Filtrar</ModalTitle>

        <ModalQuestion2>
          <ResetFilterContainer>
            <IoReload size={25} onClick={resetData} />
          </ResetFilterContainer>

          <h2>Data de Cadastro:</h2>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <div className="date_register">
              <fieldset>
                <label htmlFor="by">De:</label>
                <InputMask
                  name="by"
                  mask="99/9999"
                  id="by"
                  placeholder="Mês/Ano"
                  containerStyle={inputStyle}
                  fontSize="1.8rem"
                  value={by}
                  onChange={(e) => setBy(e.target.value)}
                />
              </fieldset>

              <fieldset>
                <label htmlFor="from">Até:</label>
                <InputMask
                  name="from"
                  mask="99/9999"
                  id="from"
                  containerStyle={inputStyle}
                  fontSize="1.8rem"
                  placeholder="Mês/Ano"
                  value={from}
                  onChange={(e) => setFrom(e.target.value)}
                />
              </fieldset>
            </div>
          </Form>
        </ModalQuestion2>

        <ModalQuestion2>
          <h2>Status:</h2>
          <div className="status">{statusFilterOptions}</div>
        </ModalQuestion2>

        <ButtonBlack
          disabled={loading}
          onClick={() => formRef.current?.submitForm()}
        >
          Aplicar
        </ButtonBlack>
      </ModalFilterContent>
    </Modal>
  );
};

export default FilterModal;
